import { useCallback } from 'react';
import { useSelector } from 'react-redux';

export function useUser() {
  const userPermissions = useSelector(
    (state) => state.user.authorizePermissions
  );
  const superadmin = useSelector((state) => state.user.superadmin);

  const hasPermission = useCallback(
    (permissions) => {
      if (superadmin) return true;
      if (!Array.isArray(userPermissions)) return false;
      const keys = Array.isArray(permissions) ? permissions : [permissions];
      return keys.some((key) => key && userPermissions.includes(key));
    },
    [userPermissions, superadmin]
  );

  const hasRole = useCallback(
    (roles) => {
      const list = Array.isArray(roles) ? roles : [roles];
      if (list.includes('superadmin')) {
        return Boolean(superadmin);
      }
      return false;
    },
    [superadmin]
  );

  return { hasPermission, hasRole, isSuperadmin: Boolean(superadmin) };
}

export default useUser;
